<template>
  <div>
    <div class="air__utils__heading">
      <h5>Google Classroom Links</h5>
    </div>
    <a-card>
      <a-alert type="info" message="Coming Soon" description="The interface to link Google Classroom courses to school subjects will be implemented here." showIcon />
    </a-card>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
}
</script>
